import {detect} from "detect-browser";

const browser = detect();
export const MOBILE_DEVICE = (browser.os === 'Android OS' || browser.os === 'iOS')? true: false;
